import React from 'react';

/**
 * IB-701 — shared segmented control used across the redesigned Procurement face (the Plan tab's
 * Category | Department group toggle and the Setup tab's Policy | Categories switch, plus the
 * Approvals TYPE filter). Lifted verbatim out of PlanTab so the styling stays identical. Colours
 * come from tailwind.config.js; no new tokens are introduced.
 */
const SegmentedControl = ({ label, options, value, onChange }) => (
    <div className="tw-flex tw-items-center tw-gap-2">
        {label && <span className="tw-text-xs tw-font-medium tw-uppercase tw-tracking-wide tw-text-charcoal-50">{label}</span>}
        <div className="tw-inline-flex tw-items-center tw-gap-1 tw-rounded-lg tw-bg-charcoal-10 tw-p-1">
            {options.map((option) => (
                <button
                    key={option.value}
                    type="button"
                    onClick={() => onChange(option.value)}
                    className={
                        value === option.value
                            ? 'tw-rounded-md tw-bg-white tw-px-3 tw-py-1 tw-text-sm tw-font-medium tw-text-charcoal tw-shadow-sm'
                            : 'tw-rounded-md tw-px-3 tw-py-1 tw-text-sm tw-font-medium tw-text-charcoal-50 hover:tw-text-charcoal'
                    }
                >
                    {option.label}
                </button>
            ))}
        </div>
    </div>
);

export default SegmentedControl;
